<template>
  <div class="my">
    <NavBar />
    <div style="width: 100%;height: 125px;margin-bottom: -3px;display: flex;justify-content: center;align-items: center">
      <img style="width: 100px;height: 100px;" src="../../assets/ELogo@2x.svg" alt="">
    </div>
    <van-cell title="名字" :value="detail.name" />
    <van-cell title="地址" :value="detail.address" />
    <van-cell title="电话" :value="detail.telPhone" />
  </div>
</template>
<script>
import { getAboutu } from '@/api/index'
export default {
  data() {
    return {
      detail: {}
    }
  },
  mounted() {
    getAboutu().then(res => {
      this.detail = res
    })
  }
}
</script>
<style lang="scss">
  .my{
    .van-cell__title{
      flex: 0.5;
      min-width: 30px;
    }
    .van-cell__value{
      flex: 1;
    }
  }
</style>
